import React from "react";
import "./style.css";

export const FlexcontainerWrapper = () => {
  return (
    <div className="flexcontainer-wrapper">
      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          Except for any money-back rights provided by applicable law, if you
          purchased the application directly through our website and saw the
          money-back option at checkout, you may qualify to request a money-back
          under the following conditions:
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">You must contact us at </span>

        <span className="text-wrapper-3">website@caloapp.ai</span>

        <span className="text-wrapper-2">
          {" "}
          within 30 days of your initial purchase and request a money-back
          before the end of the subscription period.
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          You need to follow our program, with the specific time frames as
          follows:
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          For monthly or longer subscriptions, you must participate for at least
          7 consecutive days;
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          For 4-week subscriptions, you must participate for at least 5
          consecutive days;
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          For weekly or bi-weekly subscriptions, you must participate for at
          least 3 consecutive days.
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          You must be able to prove that you followed the program as described
          in the &#34;How to demonstrate Your Program Participation&#34;
          section.
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          We will review your money-back request and notify you of the status
          via email or other means.
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-4">
          How to demonstrate Your Program Participation
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          To demonstrate that you followed the program, you need to provide
          screenshots from the application showing that you have completed:
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          For monthly or longer subscriptions, at least 7 consecutive days of
          calorie tracking, macro tracking, or other activities;
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          For 4-week subscriptions, at least 5 consecutive days of calorie
          tracking, macro tracking, or other activities;
          <br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-2">
          For weekly or bi-weekly subscriptions, at least 3 consecutive days of
          calorie tracking, macro tracking, or other activities .<br />
        </span>
      </p>

      <p className="flexcontainer-wrapper-div">
        <span className="text-wrapper-4">Important Note: </span>

        <span className="text-wrapper-2">
          Meeting the above requirements is a prerequisite for applying for a
          money-back. This money-back guarantee does not apply to other
          circumstances. We reserve the right to request additional proof or
          verify the authenticity of submitted materials.
        </span>
      </p>
    </div>
  );
};
